import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '../ui/button';
import { 
  shouldShowConsentBanner, 
  setConsentStatus, 
  hasAcceptedTracking 
} from '../../config/analytics';
import { initializeAnalytics, trackPageView } from '../../services/analytics';

/**
 * Cookie Consent Banner
 * 
 * Minimal, compliant consent banner for tracking.
 * Tracking only fires after user accepts.
 */
export const CookieConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if banner should be shown
    setIsVisible(shouldShowConsentBanner());
  }, []);

  const handleAccept = () => {
    setConsentStatus('accepted');
    setIsVisible(false);
    
    // Initialize tracking after consent
    initializeAnalytics();
    
    // Track the current page
    trackPageView(window.location.pathname, document.title);
  };

  const handleReject = () => {
    setConsentStatus('rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-gray-200 shadow-lg"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-gray-700">
              We use cookies to analyze site usage and improve your experience. 
              No personal information is shared with analytics providers.
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <Button
              variant="outline"
              size="sm"
              onClick={handleReject}
              className="text-gray-600 border-gray-300 hover:bg-gray-50"
              data-testid="cookie-reject-btn"
            >
              Reject
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="bg-[hsl(215,50%,23%)] text-white hover:bg-[hsl(215,50%,18%)]"
              data-testid="cookie-accept-btn"
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
